import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  CircularProgress
} from '@mui/material';

const ConfirmDeleteModal = ({
  heading = "Confirm Deletion",
  description = "Are you sure you want to delete this item?",
  isOpen,
  onClose,
  handleDelete,
  isLoading
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          mx: 'auto',
          mt: '15%',
        }}
      >
        <Typography id="modal-title" variant="h6" fontWeight={600} mb={1}>
          {heading}
        </Typography>
        <Typography id="modal-description" variant="body1" mb={3}>
          {description}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            variant="contained"
            color="error"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmDeleteModal;
